import { AppState } from '../root.reducer';

export const countriesSelector = (state: AppState) => state.meta.countries;
export const companiesSelector = (state: AppState) => state.meta.companyCount;
export const isMobilMenuOpen = (state: AppState) => state.meta.isMobilMenuOpen;